import { X } from "lucide-react";
import React, { useState } from "react";
import { Button } from "@/components";
import { useApi } from "@/";
const VerifyEmailDialog = ({ isOpen, onClose, userEmail }) => {
  const [isVerifying, setIsVerifying] = useState(false);
  const { callApi, loading } = useApi();

  const handleVerifyEmail = async () => {
    try {
      setIsVerifying(true);
      await callApi("common/send-email-verification", "POST", {
        email: userEmail,
      });
      onClose();
    } catch (error) {
      console.error("Verification failed:", error);
    } finally {
      setIsVerifying(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center ">
      <div className="bg-white p-6 rounded-2xl max-w-sm w-full mx-4 relative">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 bg-background_2/60 hover:bg-primary/30 transition-all rounded-md p-1"
        >
          <X className="w-3 h-3 text-secondary/60" />
        </button>
        <h2 className="text-headline4 font-nunito text-secondary/90 font-bold mb-4">
          Verify Your Email
        </h2>
        <p className="text-secondary/80 text-subtitle2 mb-4">
          Click the button below to receive a verification email at {userEmail}
        </p>
        <Button
          onClick={handleVerifyEmail}
          isLoading={loading}
          className="w-full"
        >
          "Send Verification Email"
        </Button>
      </div>
    </div>
  );
};

export default VerifyEmailDialog;
